import { CombinedVueInstance } from 'vue/types/vue';
import { Component, Mixins } from 'vue-property-decorator';
import PopupComponent from '@/components/messageBox/popup';
import {
    dateFormat,
    dateNow,
} from '@/lib/utils';
import store from '@/store';
import router from '@/router';
import {
    ROUTE_NAME,
    datePopup,
} from '@/lib/constant';

// 倒计时弹窗
@Component({
    name: 'CountdownPopup',
    template: `<MyPopup v-if="value" v-model="value" class="countdown-popup" :content-class="['center-popup']" position="center" :modal="true">
        <div class="icon-wrap">
            <i class="icon" @click="onClickClose">&#xe60b;</i>
        </div>
        <img class="image" v-thumbnail="countdownImage" />
        <div v-if="activityDetail && !activityDetail.joined && activityDetail.startParticipation" class="btn-wrap">
            <MobileButton name="yellow-gradient"
                class="btn-large btn-round"
                @click="onClickMarket">
                去报名
            </MobileButton>
        </div>
    </MyPopup>`,
})
export class CountdownPopup extends Mixins(PopupComponent) {
    /** 倒计时显示的弹窗图片内容 */
    public get countdownImage() {
        const key = dateFormat(dateNow());
        return datePopup[key];
    }
    /** 活动id */
    public get activityId() {
        return store.getters['activity/activityId'];
    }
    public get activityDetail() {
        return store.state.activity.basicInfo[this.activityId];
    }

    public onClickClose() {
        this.value = false;
    }
    /**
     * 营销活动弹窗按钮
     */
    public onClickMarket() {
        this.value = false;
        router.push({
            name: ROUTE_NAME.ACTIVITY_SUBMIT_ORDER,
            params: {
                activityId: this.activityId,
            },
        });
    }
}

export type CountdownPopupComponent = CombinedVueInstance<CountdownPopup, object, object, object, Record<keyof object, any>>;
